<template>
    <v-card class="mx-auto" shaped elevation="7" min-height="700px">
        <v-card-title>
            Póliza Tradicional
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="close(true)">Nuevo</v-btn>
            <ModalPolizaTradicionalComponent :open="obModal.open" :obModal="obModal" :listGeneral="listGeneral" :parametros="parametros" />
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Contratante *" color="textbox" v-model="obSearch.idContratante"
                            :items="listGeneral.listContratante" item-text="contratante" item-value="idContratante"
                            @change="onListarAseguradora" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="obSearch.idAseguradora"
                            :items="listGeneral.listAseguradora" item-text="aseguradora" item-value="idAseguradora"
                            outlined dense @change="onListarSeguro"/>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Seguro *" color="textbox" v-model="obSearch.idSeguro"
                            :items="listGeneral.listSeguro" item-text="seguro" item-value="idSeguro"
                            outlined dense />
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="obSearch.idEstado"
                            :items="listGeneral.listEstado" item-text="nombre_estado" item-value="id_estado"
                            outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-tooltip top color="primary">
                                <template v-slot:activator="{ on }">
                                    <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                            :disabled="disabled">
                                            <v-icon dark>search</v-icon>
                                    </v-btn>
                                </template>
                                <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="12" sm="4"/>
                </v-row>

                <v-row dense>
                    <v-col v-if="_.size(listGeneral.detalle) == 0" cols="12" sm="6"/>
                    <v-col v-else cols="12" sm="6">
                        <v-btn rounded color="primary" dark @click="exportar('tableInfLiqCom','Informe de Liquidación Comisión Prima')">Exportar a XLSX</v-btn>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                                dense prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera" 
                                :items="listGeneral.detalle" class="elevation-3" id="tableInfLiqCom">
                                
                                <template v-slot:item.valorAsegurado="{ item }">
                                    {{ `$${Number.parseFloat(item.valorAsegurado).toFixed(2)}`  }}
                                </template>

                                <template v-slot:item.name="{ item }">
                                    <v-btn class="ma-2" text icon color="primary" @click="edit(item)">
                                            <v-icon small>edit</v-icon>
                                    </v-btn>
                                </template>

                                <template v-slot:no-results>
                                    Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó
                                    resultados.
                                </template>
                        </v-data-table>
                    </v-col>
                </v-row>

            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'PolizaTradicionalView',
        components:{
            ModalPolizaTradicionalComponent: () => import('@/components/constructor/polizaTradicional/ModalPolizaTradicionalComponent.vue')
        },
        data: () => ({
            obSearch:{  
                search:'',
                opcion:'LISTAR',
                idContratante:null,
                idAseguradora:null,
                idSeguro:null,
                idEstado:null
            },
            obModal:{
                titulo:'Nueva Póliza Tradcional',
                open:false
            },
            listGeneral: {},
            parametros: {},
            disabled:false
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/poliza-tradicional/cargaGeneral`)
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.obSearch.idEstado = _.toString(this.parametros.idEstadoDefault);
                        this.obSearch.idContratante = _.get(this.listGeneral,['listContratante','0','idContratante'],null);
                        return Promise.all([this.onListarAseguradora('L'),this.onListar('L')]);
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,error);
                 });
        },
        methods:{
            onListarAseguradora(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    var o = {
                        opcion:'L_ASEGURADORA_X_CONTRATANTE',
                        idContratante:this.obSearch.idContratante,
                        idEstado:this.obSearch.idEstado
                    }

                    this.listGeneral.listAseguradora = [];
                    axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                this.listGeneral.listAseguradora = r.data.data;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            onListarSeguro(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';
                    var o = {
                        opcion:'L_SEGURO_X_ASEGURADORA',
                        idContratante:this.obSearch.idContratante,
                        idAseguradora:this.obSearch.idAseguradora,
                        idTipoPoliza:this.parametros.idTipoPolizaNormal,
                        idEstado:this.obSearch.idEstado
                    }

                    this.listGeneral.listSeguro = [];
                    axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                this.listGeneral.listSeguro = r.data.data;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            onListar(ev){
                if(!_.isUndefined(ev)){
                    var error = 'E';

                    axios.post(`${BASE_URI}administrador/poliza-tradicional/listar`,_.omit(this.obSearch,'search'))
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) {error = 'I';  throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);}
                                this.listGeneral.detalle = r.data.data;
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            edit(v){
                this.obModal = _.merge({titulo:'Editar Póliza Tradicional',open:true},v);
            },
            close(band){
                this.obModal = {
                    titulo:'Nueva Póliza Tradicional',
                    open:band
                }
            }
        },
        provide(){
            return{
                close:this.close,
            }
        }
    }
</script>